import { render, staticRenderFns } from "./IgCard.vue?vue&type=template&id=21e2cfa5&"
import script from "./IgCard.vue?vue&type=script&lang=js&"
export * from "./IgCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports